.twoYearOfferCard {
	@apply yst-mb-4 yst-border-purple-200 yst-border;

	&.hidden{
		@apply yst-hidden #{!important}
	}

	.container {
		@apply yst-flex yst-gap-3 yst-m-0 #{!important};

		.title {
			@apply yst-text-base yst-mb-2 #{!important};
		}

		.tableContainer{
			@apply yst-grow yst-max-w-5xl yst-space-y-2;

			.table {
				th:last-child {
					@apply yst-text-right;
				}

				td {
					@apply yst-align-text-top;
				}

				td:last-child {
					@apply yst-text-right;
				}
			}
		}
	}

	.error{
		@apply yst-mb-3;
	}

	p {
		@apply yst-max-w-[640px] yst-mb-4 #{!important};
	}
}

.modalTitle {
	@apply yst-mb-3 #{!important};
}

.hr {
	@apply yst-mb-5 #{!important};
}

.small {
	@apply yst-text-xs;
}

.buttonContainer {
	@apply yst-flex yst-justify-end yst-gap-2;
}

.toastContainer {
	svg {
		@apply yst-w-6 yst-h-6 yst-min-w-6;
	}

	.toastFlex {
		@apply yst-flex yst-gap-3 yst-relative;
	}

	.checkIcon {
		@apply yst-text-green-500;
	}

	.infoIcon {
		@apply yst-text-blue-500;
	}

	.buttonPosition {
		@apply yst-flex yst-justify-end;
	}

	.undoButton {
		@apply yst-p-0;
	}
}

.toastClose {
	@apply yst-absolute yst-right-0 yst-top-0;
}


